export default __webpack_public_path__ + "static/media/ba3f8ae36ccbcd623a6e440d2c27c1b3.png";